module.exports = __webpack_public_path__ + "static/media/icon-bootstrap.e99f0665.svg";